<template>
  <div class="news-list" :style="containerStyle">
    <div class="news" :style="{ width: width }">
      <div class="news-tit" style="display: flex">
        <span style="color: #000000">搜索结果</span>
        <i
          style="color: #67686b"
          class="el-icon-close"
          @click="closeNewsList"
        />
      </div>
      <div style="flex: 1; height: calc(100% - 60px)">
        <el-scrollbar style="height: 100%">
          <div class="news-content">
            <div
              v-for="(item, index) in getNewsList()"
              :key="item.url"
              class="news-item"
              @click="openNewsUrl(item.url)"
            >
              <!-- <div class="item-tit">
                <div class="item-tit-lf">
                  <img
                    :src="item.sourceIcon"
                    alt=""
                  />
                  <span class="sp-tit">{{ item.source }}</span>
                  <span class="sp-time">{{ item.publishTime }}</span>
                </div>
                <div class="item-tit-rg">{{ item.id }}</div>
              </div> -->
              <div class="item-tit" style="display: flex">
                <div class="item-new-tit ellipsis ellipsis-1">
                  {{ item.title }}
                </div>
                <div class="item-tit-rg">{{ item.id }}</div>
              </div>
              <div class="item-new-dec ellipsis ellipsis-2">
                {{ item.content }}
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'element-ui'

export default {
  inject: ['getNewsList', 'setNewsList'],
  props: {
    width: {
      type: [String, Number],
      default: '28vw'
    },
    padding: {
      type: Object,
      default: () => ({
        top: '42px',
        right: '24px',
        bottom: '16px',
        left: '0'
      })
    }
  },
  data() {
    return {}
  },
  computed: {
    containerStyle() {
      const { top, right, bottom, left } = this.padding
      return {
        paddingTop: typeof top === 'number' ? `${top}px` : top,
        paddingRight: typeof right === 'number' ? `${right}px` : right,
        paddingBottom: typeof bottom === 'number' ? `${bottom}px` : bottom,
        paddingLeft: typeof left === 'number' ? `${left}px` : left
      }
    }
  },

  methods: {
    closeNewsList() {
      this.setNewsList([])
    },
    formatDate(date) {
      if (!date) return ''
      return dayjs(date).format('YYYY-MM-DD')
    },
    openNewsUrl(url) {
      if (!url) return
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.ellipsis {
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 省略号 */
  word-break: break-all; /* 确保长单词也会被截断 */
}
.ellipsis-1 {
  white-space: nowrap; /* 强制单行显示 */
  display: block; /* 改用块级显示 */
  width: 100%; /* 确保宽度占满 */
}
.ellipsis-2 {
  display: -webkit-box; /* 将元素设置为盒子模型 */
  -webkit-box-orient: vertical; /* 垂直方向的盒子模型 */
  -webkit-line-clamp: 2; /* 显示2行文本 */
}
.news-content {
  padding: 0 20px;
}
.news-list {
  height: 100%;
  width: fit-content;
  background: #fff;
  .news {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e5e9e9;
    box-shadow: 0 2px 6px 0 #0000001a;
    min-width: 200px; /* 设置最小宽度为 200px */
    max-width: 500px; /* 设置最大宽度，防止在大屏幕上太宽 */
    width: clamp(200px, 30vw, 500px); /* 使用 clamp 设置响应式宽度 */
    .news-tit {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 11px 11px 11px 20px;
      border-bottom: 1px solid #e5e9e9;
      background: #f9fbff;
      span {
        font-family: 'PingFang SC';
        font-size: 16px;
        font-weight: 500;
      }
      i {
        font-size: 16px;
        cursor: pointer;
      }
    }

    .news-item {
      padding-top: 7px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f6f6f6;
      cursor: pointer;
      .news-item,
      .item-new-dec {
        font-family: 'PingFang SC';
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
      }
      .item-new-tit {
        padding: 17px 0;
        color: #000000;
        flex: 1; /* 让标题占据剩余空间 */
        min-width: 0; /* 允许内容收缩 */
        font-size: 14px;
        font-weight: 600;
      }
      .item-new-dec {
        color: #777777;
      }
      .item-tit {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        width: 100%; /* 确保容器占满宽度 */
        .item-tit-lf {
          display: flex;
          align-items: center;
          gap: 6px;
          .sp-tit {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
          }
          .sp-time {
            color: #777777;
            font-size: 12px;
            font-weight: 400;
          }
        }
        .item-tit-rg {
          height: 20px;
          width: 20px;
          line-height: 20px;
          text-align: center;
          background: #f4f4f4;
          font-size: 14px;
          color: #000;
          border-radius: 50%;
          flex-shrink: 0; /* 防止序号被压缩 */
        }
        img {
          height: 20px;
          width: 20px;
        }
      }
    }
  }
}
</style>
